import gql from 'graphql-tag'

export const eventResultFragment = gql`
  fragment eventResult on EventResult {
    id
    slug
    name
    startDate
    endDate
    locationName
    cityName
    country {
      name
      code
    }
  }
`
